import { URL_ME, API_WALLET_URL, URL_ACTIVITIES } from 'config'
import { apiCall } from './base'

export const getBalance = () =>
  apiCall(`${URL_ME}/api/v1/me/balance`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  }).then((res) => res.data)

export const getActivities = (params, wallet_uuid) => {
  const apiURL = () =>
    params.created_until
      ? `${URL_ACTIVITIES}/api/v1/activities/?page[number]=${params.pageNumber}&filter[wallet_account]=${wallet_uuid}&filter[created_from]=${params.created_from}&filter[created_until]=${params.created_until}`
      : `${URL_ACTIVITIES}/api/v1/activities/?page[number]=${params.pageNumber}&filter[wallet_account]=${wallet_uuid}&filter[created_from]=${params.created_from}`
  return apiCall(apiURL(), {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  }).then((res) => res.data)
}

export const getActivity = (id) =>
  apiCall(`${URL_ACTIVITIES}/api/v1/activities/${id}`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  }).then((res) => res.data.data)

export const getEntity = (code) =>
  apiCall(`${URL_ME}/api/v1/me/banks/entity/${code}`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  })

export const getExternalAccountContacts = () =>
  apiCall(`${URL_ME}/api/v1/bank/external-account/contacts`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  })

export const createExternalAccount = (data) =>
  apiCall(`${URL_ME}/api/v1/bank/external-account`, {
    baseURL: API_WALLET_URL,
    method: 'POST',
    withCredentials: false,
    immediately: true,
    data
  })

export const getContact = (taxID) =>
  apiCall(`${URL_ME}/api/v1/bank/external-account/${taxID}`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  })
